import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "../cn";

/* Same surface as Input (StepDetails.tsx), with textarea extras. */
export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    invalid?: boolean;
    /** Resize behavior — "none" | "vertical" | "both". Default: vertical. */
    resize?: "none" | "vertical" | "both";
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className, invalid, resize = "vertical", ...rest }, ref) => (
        <textarea
            ref={ref}
            className={cn(
                "w-full rounded-xl border bg-black/20 px-3.5 py-2.5 text-sm font-medium leading-relaxed text-white outline-none transition",
                "placeholder:text-zinc-500",
                resize === "none" && "resize-none",
                resize === "vertical" && "resize-y",
                resize === "both" && "resize",
                invalid
                    ? "border-red-500/50 focus:border-red-400 focus:ring-2 focus:ring-red-400/15"
                    : "border-white/10 focus:border-orange-400/60 focus:ring-2 focus:ring-orange-400/15",
                "disabled:cursor-not-allowed disabled:opacity-50",
                className
            )}
            {...rest}
        />
    )
);

Textarea.displayName = "Textarea";
